export function isEmbeddedApp() {
  return typeof window !== "undefined" && window.self !== window.top;
}
